import { React } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import TooltipIcon from './TooltipIcon';

function GreenTitleBox({ title, helpText }) {
  return (
    <Flex alignItems='center' mb='12px'>
      <Text fontWeight='700' color='green.500'>
        {title}
      </Text>
      <TooltipIcon helpText={helpText} />
    </Flex>
  );
}

export default GreenTitleBox;
